import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNodesServiceClient } from "../../services/brainflex/NodesServiceClient";
import type { Node } from "../../services/brainflex/NodesServiceClient";
import ServiceTransaction from "../../services/ServiceTransaction";

const NodeDetails: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [node, setNode] = useState<any>(null);
  const nodesServiceClient = useNodesServiceClient();

  useEffect(() => {
    const fetchNode = async () => {
      const transaction: ServiceTransaction<Node> = await nodesServiceClient.getNode(Number(id));
      if (transaction.response.isSuccess) {
        setNode(transaction.response.success!.data);
      } else {
        // handle error
      }
    };
    fetchNode();
  }, [id, nodesServiceClient]);

  // Fetch and display details for node with this id
  return (
    <>
      <h1>Node Details</h1>
      <div>Node Details for ID: {id}</div>
      {node && (
        <pre>{JSON.stringify(node, null, 2)}</pre>
      )}
    </>
  );
};

export default NodeDetails;